import { canAccessSamplePack, isTokenGated, SamplePack } from '@arpeggi/shared'
import { Icons } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { useIsSPEditionHolder } from '../../token-gating/hooks'
import { useVerifyMedia } from '../../verified-media'
import { useHashTabs, useShowUploadDownload } from '../hooks'
import { Navbar } from '../primitives'
import { DiscussionTabContent } from './DiscussionTabContent'
import { RemixCompetitionModal } from './RemixCompetitionModal'
import { SPActions } from './SPActions'
import { SPCollectTabContent } from './SPCollectTabContent'
import { SPDetailsTabContent } from './SPDetailsTabContent'
import { SPRemixesTabContent } from './SPRemixesTabContent'
import { SPSamplesTabContent } from './SPSamplesTabContent'
import { SPVerifiedTabContent } from './SPVerifiedTabContent'
import { Tab } from './Tab'

const imitateDLClick = () => {
  document.getElementById('download-modal').click()
}

export const SPSecondarySection: FC<{ sp: SamplePack }> = observer(({ sp }) => {
  const { isHolder, status } = useIsSPEditionHolder(sp)
  const verifyData = useVerifyMedia({ samplePackId: sp?.id })
  const showUploadDownload = useShowUploadDownload(sp, isHolder)
  const { currentTab, setTab } = useHashTabs('#samples')
  const hasVerifiedRemixes = verifyData.verifiedIDs?.length > 0
  const navigate = useNavigate()
  const { user } = useAuth()

  const isTokenGatedSP = isTokenGated(sp)

  return (
    <>
      {/* Hard coded to show the remix competition modal for orrin's competition */}
      {showUploadDownload && sp.id === 19 && (
        <RemixCompetitionModal user={sp.user} handleDownload={() => imitateDLClick()} />
      )}
      <Tabs.Root value={currentTab} onValueChange={setTab}>
        <Navbar.Root>
          <Navbar.Content>
            <Navbar.TabArea>
              <Tabs.List>
                {isTokenGatedSP && <Tab value="#collect" label="Collect" icon={<Icons.Trophy />} />}
                <Tab
                  value="#samples"
                  label="Samples"
                  icon={<Icons.Soundwave style={{ strokeWidth: '1.4px' }} />}
                />
                <Tab value="#tracks" label="Tracks" icon={<Icons.Remix />} />
                {hasVerifiedRemixes && (
                  <Tab value="#verified" label="Verified" icon={<Icons.Verified />} />
                )}
                <Tab value="#details" label="Details" icon={<Icons.Details />} />
                {isTokenGatedSP && (
                  <Tab value="#discussion" label="Discussion" icon={<Icons.Comment />} />
                )}
              </Tabs.List>
            </Navbar.TabArea>
            <Navbar.Actions>
              <SPActions sp={sp} />
            </Navbar.Actions>
          </Navbar.Content>
        </Navbar.Root>
        {isTokenGatedSP && <SPCollectTabContent sp={sp} />}
        <SPSamplesTabContent sp={sp} />
        <SPRemixesTabContent sp={sp} />
        {hasVerifiedRemixes && <SPVerifiedTabContent sp={sp} />}
        <SPDetailsTabContent sp={sp} />
        {isTokenGatedSP && status === 'ready' && (
          <DiscussionTabContent
            discussionId={sp.discussionId}
            isBlocked={!canAccessSamplePack(sp, isHolder, user)}
            emptyStateOnClick={() => navigate(`/sample-packs/${sp.id}#collect`)}
          />
        )}
      </Tabs.Root>
    </>
  )
})
